import { useCallback, useState, type MouseEvent } from 'react';

interface ContextMenuPosition {
  mouseX: number;
  mouseY: number;
}

interface UseContextMenuReturn<T> {
  contextMenu: ContextMenuPosition | null;
  rightClickedItem: T | null;
  openContextMenu: (event: MouseEvent, item: T) => void;
  closeContextMenu: () => void;
}

export const useContextMenu = <T>(): UseContextMenuReturn<T> => {
  const [contextMenu, setContextMenu] = useState<ContextMenuPosition | null>(null);
  const [rightClickedItem, setRightClickedItem] = useState<T | null>(null);

  const openContextMenu = useCallback((event: MouseEvent, item: T) => {
    event.preventDefault();
    event.stopPropagation();

    setRightClickedItem(item);
    setContextMenu({ mouseX: event.clientX - 2, mouseY: event.clientY - 4 });
  }, []);

  const closeContextMenu = useCallback(() => {
    setContextMenu(null);
    setRightClickedItem(null);
  }, []);

  return { contextMenu, rightClickedItem, openContextMenu, closeContextMenu };
};
